import { render, staticRenderFns } from "./shared_projects_empty_state.vue?vue&type=template&id=790e2208&vue3"
import script from "./shared_projects_empty_state.vue?vue&type=script&lang=js&vue3"
export * from "./shared_projects_empty_state.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports